import { classnames } from 'Utils/classnames/classnames.utils';

const small = {
  thRoot: 'flex flex-wrap font-bold gap-5 items-center leading-tight text-green text-14',
  thLastLabel: 'bg-orange font-bold px-10 py-5 rounded-pill text-12 text-white w-auto',
  thStock: 'flex gap-2 items-center min-w-1/2 text-orange text-12 w-auto',
  thIconLastSize: '1em',
  thIconSize: '0.75em',
};

export const themes = {
  default: small,
  medium: { ...small },
  large: {
    ...small,
    thRoot: classnames(small.thRoot, 'md:text-16'),
    thLastLabel: classnames(small.thLastLabel, 'md:text-14'),
    thStock: classnames(small.thStock, 'md:mt-0 md:min-w-0 md:text-14'),
  },
};
